
import { put, takeEvery } from 'redux-saga/effects';
import { actionType } from "../../troubleShooting/articleDetail/action";
import data from  "../../../assets/lang/jp/article-detail-page";
import api from '../../../services/API';
import { config }  from "../../../config";
function* fetchPageData() {
  let detailPageData = {
    data: data.data
  };
  
  if(config.env !=='localhost') {
    detailPageData.data  = {...detailPageData.data ,...data[config.env]} 
  }  
  yield put({ type: actionType.ARTICLE_DETAIL_RESPONSE, payload: detailPageData });
}



/**
 * getArticleDetail to call the article detail API
 * @method: articleId
 * @output: object data of article detail page
 */
function* getArticleDetail(params ){  
  
 try {

    const articleDetail =  yield api.article.getDetailById(params.payload);   
    
    yield put({
      type: actionType.ARTICLE_DETAIL_API_SUCCESS,
      payload: articleDetail
    })
  } catch (exception) {        
    yield put({
      type: actionType.ARTICLE_DETAIL_API_FAILURE,
      payload: exception
    })
  } 
    
}

/**
 * save feedback method
 */

function* saveFB(params ){  
  
  try {
 
     const saveFBResponse =  yield api.article.saveFeedback(params.payload);   
     
     yield put({
       type: actionType.FB_API_SUCCESS,
       payload: saveFBResponse
     });
     
   } catch (exception) {    
     yield put({
       type: actionType.FB_API_FAILURE,
       payload: exception.response
     })
   } 
     
 }

 
/**
 * SaveAccessFootPrint method to save Access Footpring log
 */

function* SaveAccessFootPrint(params ){  
    
  try {
    
     const response =  yield api.article.SaveAccessFootPrint(params.payload);  
     yield put({
       type: actionType.ACCESS_FP_API_SUCCESS,
       payload: response
     });
     
   } catch (exception) {    
     yield put({
       type: actionType.ACCESS_FP_API_FAILURE,
       payload: exception.response
     })
   } 
     
 }

 


/**
 * UpdateAccessFootPrint method to update article reading time
 */

function* UpdateAccessFootPrint(params ){  
    
  try {
 
     const response =  yield api.article.UpdateAccessFootPrint(params.payload);   
    
     yield put({
       type: actionType.ACCESS_FP_UPDATE_API_SUCCESS,
       payload: response
     });
     
   } catch (exception) {    
     yield put({
       type: actionType.ACCESS_FP_UPDATE_API_FAILURE,
       payload: exception.response
     })
   } 
     
 }


/**
 * Call the all sagas method here
*/

export const articleDetailSagas = [
  takeEvery(actionType.ARTICLE_DETAIL_REQUEST, fetchPageData),
  takeEvery(actionType.ARTICLE_DETAIL_API_REQUEST, getArticleDetail),
  takeEvery(actionType.FB_API_REQUEST, saveFB),
  takeEvery(actionType.ACCESS_FP_API_REQUEST,SaveAccessFootPrint),
  takeEvery(actionType.ACCESS_FP_UPDATE_API_REQUEST,UpdateAccessFootPrint)
    
]